import dayjs from 'dayjs'
import React from 'react'
import { TileArgs } from 'react-calendar'
import { FormattedMessage } from 'react-intl'

import { DatesCalendarProps } from '../../dates-calendar'
import { computeHouseAvailabilityState } from '../../helpers/compute-house-availability-state.helper'
import { getAvailabilityFromDate } from '../../helpers/get-availability-from-date.helper'
import { TravelTypeEnum } from '../../../../../lib/graphql'

type TileContentProps = Pick<TileArgs, 'date'> &
  Pick<DatesCalendarProps, 'houseAvailabilities'> & {
    travelType: TravelTypeEnum | null
    house: DatesCalendarProps['house']
  }

export const TileContent = (props: TileContentProps) => {
  const { date, house, houseAvailabilities, travelType } = props

  if (!house) {
    return null
  }

  const houseAvailability = getAvailabilityFromDate({
    date,
    houseAvailabilities,
  })

  const { isCorporateEveningLocked, isNightlyTripLocked, isStudyDayLocked } =
    computeHouseAvailabilityState({
      ...props,
      houseAvailability,
    })

  return (
    <>
      {travelType ? (
        <div className='overlay__container'>
          <div className='overlay__dateLabel'>
            {dayjs(date).utc(true).format('DD/MM/YYYY')}
          </div>

          {travelType === TravelTypeEnum.NIGHTLY_TRIP ? (
            <div className='overlay__details'>
              <FormattedMessage
                id='ui.DatesCalendar.nightlyTrip'
                defaultMessage='Nuitée {availability}'
                values={{
                  availability: isNightlyTripLocked ? (
                    <FormattedMessage
                      id='ui.DatesCalendar.nightlyTrip.unavailable'
                      defaultMessage='indisponible'
                    />
                  ) : (
                    <>
                      <div className='overlay__details'>
                        <FormattedMessage
                          id='ui.DatesCalendar.arrival'
                          defaultMessage='Arrivée {arrival}'
                          values={{ arrival: house?.arrival || '15h00' }}
                        />
                      </div>

                      <div className='overlay__details'>
                        <FormattedMessage
                          id='ui.DatesCalendar.departure'
                          defaultMessage='Départ {departure}'
                          values={{ departure: house?.departure || '11h00' }}
                        />
                      </div>
                    </>
                  ),
                }}
              />
            </div>
          ) : null}

          {travelType === TravelTypeEnum.DAILY_TRIP ? (
            <div className='overlay__details'>
              <FormattedMessage
                id='ui.DatesCalendar.awayDay'
                defaultMessage="Journée d'étude {availability}"
                values={{
                  availability: isStudyDayLocked ? (
                    <FormattedMessage
                      id='ui.DatesCalendar.awayDay.unavailable'
                      defaultMessage='indisponible'
                    />
                  ) : (
                    <FormattedMessage
                      id='ui.DatesCalendar.awayDay.available'
                      defaultMessage='disponible'
                    />
                  ),
                }}
              />
            </div>
          ) : null}

          {travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT ? (
            <div className='overlay__details'>
              <FormattedMessage
                id='ui.DatesCalendar.corpotateEvening'
                defaultMessage='Soirée {availability}'
                values={{
                  availability: isCorporateEveningLocked ? (
                    <FormattedMessage
                      id='ui.DatesCalendar.corpotateEvening.unavailable'
                      defaultMessage='indisponible'
                    />
                  ) : (
                    <FormattedMessage
                      id='ui.DatesCalendar.corpotateEvening.available'
                      defaultMessage='disponible'
                    />
                  ),
                }}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  )
}
